<template>
  <div
    class="selection-item"
    :class="{ '-is-selected': selected, '-is-disabled': disabled }"
    :style="itemStyle"
    @click="onClick"
  >
    <v-checkbox
      :value="selected"
      :false-value="false"
      :disabled="disabled"
      color="primary"
      :ripple="false"
      hide-details
      class="w-full mt-0 pt-0"
    >
      <template v-slot:label>
        <div class="selection-item-label">
          <div class="code">
            {{ label }}

            <span v-if="isMatchBranch" class="badge-success">
              <v-icon size="14" class="mr-1">
                mdi-check-circle-outline
              </v-icon>
              ใช้งานอยู่
            </span>
          </div>
          <div class="branch">
            <v-icon size="16" color="rgba(0,0,0,0.45)">
              mdi-store-outline
            </v-icon>
            {{ branchName }}
          </div>
        </div>
      </template>
    </v-checkbox>

    <div class="selection-item-meta">
      <div class="selection-item-meta-amount">
        <div class="meta-label">
          <v-icon size="14" color="rgba(0,0,0,0.45)">
            mdi-swap-horizontal-circle-outline
          </v-icon>
          <span>ราคา Trade-in</span>
        </div>
        <div class="meta-value">{{ amount | currency2 }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import colorBnn from '@/config/color'

export default {
  name: 'BaseTradeInVoucherSelectionItem',

  props: {
    label: {
      type: String,
      required: true,
    },
    isMatchBranch: {
      type: Boolean,
      default: false,
    },
    branchName: {
      type: String,
      default: null,
    },
    amount: {
      type: [String, Number],
      default: null,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      colorBnn,
    }
  },

  computed: {
    itemStyle() {
      if (!this.selected) return null

      return {
        backgroundColor: colorBnn['color-bnn-light'],
        border: `1px solid ${colorBnn['color-bnn']}`,
      }
    },
  },

  methods: {
    onClick() {
      if (this.disabled) return
      this.$emit('click')
    },
  },
}
</script>

<style lang="stylus" scoped>
.selection-item {
    display: flex;
    align-items: flex-start;
	flex-wrap: wrap;
    gap: 8px;

    padding: 12px;
    background-color: #ffffff;
    border: 1px solid #D0D0D0;
    cursor: pointer;

    &.-is-disabled {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
    }

    .selection-item-label {
        flex: 1;

        .code {
			display: flex;
			align-items: center;
			justify-content: space-between;

			font-size: 14px;
            font-weight: 500;
			white-space: nowrap;
            color: rgba(#000000, 0.85);
        }

		.branch {
			font-size: 14px;
			font-weight: 500;
            color: rgba(#000000, 0.65);
		}
    }

	.selection-item-meta {
        flex-basis: 100%;

		display: flex;
		flex-direction: column;


		&-amount {
			flex: 1;
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: flex-end;
			gap: 4px;
   		}

		.meta-label {
			display: flex;
			align-items: center;
			gap: 4px;

			font-size: 12px;
			color: rgba(#000000, 0.45);
		}

		.meta-value {
			font-size: 14px;
			font-weight: 700;
			color: #0071BC;
		}

	}
}

.badge-success {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 2px 6px;
	border-radius: 24px;

	font-size: 12px;
	line-height: 16px;
	font-weight: bold;
	color: #00B14F;
	background-color: #00B14F33;
}

::v-deep(.v-input__slot) {
	align-items: flex-start;
}
</style>
